import { render, staticRenderFns } from "./TabNavigator.vue?vue&type=template&id=f944b136&"
import script from "./TabNavigator.vue?vue&type=script&lang=ts&"
export * from "./TabNavigator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports